import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-stagehistory',
  imports: [],
  templateUrl: './opportunities-detail-table.html',
  styleUrl: './opportunities-detail-table.css'
})
export class OpportunitiesDetailTable {

}